export enum EnclaveAccessManagementType {
  ALLOWED = 'ALLOWED',
  COMPANY = 'COMPANY',
  FORBIDDEN = 'FORBIDDEN',
}

export enum EnclaveAccessType {
  READ_CREATE = 'READ_CREATE',
  READ_ONLY = 'READ_ONLY',
  READ_WRITE = 'READ_WRITE',
}

export enum EnclaveCredentialType {
  API_ID_KEY_PAIR = 'API_ID_KEY_PAIR',
  API_ID_SECRET_PAIR = 'API_ID_SECRET_PAIR',
  API_KEY = 'API_KEY',
  API_KEY_PASSWORD_PAIR = 'API_KEY_PASSWORD_PAIR',
  API_KEY_SECRET_MERCHANT_ID_PAIR = 'API_KEY_SECRET_MERCHANT_ID_PAIR',
  API_KEY_SECRET_PAIR = 'API_KEY_SECRET_PAIR',
  API_USERNAME_PASSWORD_PAIR = 'API_USERNAME_PASSWORD_PAIR',
  COMPANY_NAME = 'COMPANY_NAME',
  CUSTOM_TAXII_CLIENT = 'CUSTOM_TAXII_CLIENT',
  CUSTOM_URL_API_KEY_PAIR = 'CUSTOM_URL_API_KEY_PAIR',
  MISP_TWO_WAY = 'MISP_TWO_WAY',
  NONE = 'NONE',
  TAXII = 'TAXII',
  URL_SCAN = 'URL_SCAN',
}

export enum EnclaveSubscriptionMethod {
  CLOSED_RESEARCH = 'CLOSED_RESEARCH',
  INDIVIDUAL = 'INDIVIDUAL',
  SHARED = 'SHARED',
}

/**
 * Refers to the `label` property of the enclave.
 */
export enum EnclaveType {
  CLOSED_CONCRETE = 'CLOSED_CONCRETE',
  INTERNAL = 'INTERNAL',
  OPEN = 'OPEN',
  OTHER = 'OTHER',
}

/**
 * Represents an enclave object without having been parsed (exactly as sent by back-end).
 */
export type RawEnclave = {
  accessManagementType: EnclaveAccessManagementType,
  id: string,
  label: EnclaveType,
  maximumAccess: EnclaveAccessType,
  name: string,
  rowId: number,
  templateId: string,
  templateName: string,
  companyId?: string,
  description?: string,
  iconUrl?: string,
  iconSvgUrl?: string,
  ingestSource?: string,
  workflowSupported?: boolean,
};

export type RawEnclaveMetadata = {
  companyGuid: string,
  companyName: string,
  created: number,
  enclaveGuid: string,
  feedGuid: string,
  lastPulled: number,
  state: string,
};

export type Enclave = {
  id: string,
  accessType?: EnclaveAccessType,
  name?: string,
  type?: EnclaveType,
  description?: string,
  externalUrl?: string,
  iconUrl?: string,
  lastSubmitted?: number,
  subscribed?: number,
  workflowSupported?: boolean,
};
